import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TankService } from 'src/app/services/tank.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { Vehicle } from 'src/app/shared/models/Vehicle';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

@Component({
  selector: 'app-list-vehicle-page',
  templateUrl: './list-vehicle-page.component.html',
  styleUrls: ['./list-vehicle-page.component.css']
})
export class ListVehiclePageComponent implements OnInit {

  vehicles: Vehicle[] = [];
  pagedVehicles: Vehicle[] = [];
  tankName: string;
  tankId: number;
  page = 1;
  itemsPerPage = 10;
  maxSizePage = 10;
  totalItems = 0;

  constructor(private vehicleService: VehicleService, private tankService: TankService) {
  }

  ngOnInit() {
    this.tankService.getCurrentTank().subscribe((tank) => {
      if (tank) {
        this.tankName = tank.name;
        this.tankId = tank.id;
        this.listVehicles()
      }
    });
  }

  listVehicles() {
    this.vehicleService.getVehicleByTankWithPagination(this.tankId, this.page).subscribe(data => {
      this.vehicles = data.vehicles;
      this.totalItems = data.totalItems;
    }, error => {
      console.log(error);
    });
  }

  pageChanged(event: PageChangedEvent): void {
    this.page = event.page;
    this.listVehicles();
  }

  deleteVehicle(id: any,tankId: any, ) {
    if (this.vehicleService.deleteVehicle(id,tankId).subscribe(data => {
      this.listVehicles();
    }, error => {
      console.log(error);
    })) {
      return;
    }
  }
}
